const firstCodePoint = (word: string): string => Array.from(word)[0] ?? '';

export const getInitials = (name: unknown): string => {
  if (typeof name !== 'string') return '?';

  const words = name.trim().split(/\s+/).filter(Boolean);
  if (words.length === 0) return '?';

  const first = firstCodePoint(words[0]);
  const last = words.length > 1 ? firstCodePoint(words[words.length - 1]) : '';

  return `${first}${last}`.toUpperCase();
};
